var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { graphql } from "react-apollo";
import { Route, Redirect } from "react-router";
import gql from "graphql-tag";
var C = /** @class */ (function (_super) {
    __extends(C, _super);
    function C() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderRoute = function (routeProps) {
            var _a = _this.props, data = _a.data, component = _a.component;
            if (!data || data.loading) {
                // loading screen
                return (React.createElement("div", null,
                    React.createElement("h1", null, "LOADING")));
                // return null;
            }
            if (!data.me || !data.me.user || !data.me.user.email) {
                // user not logged in
                // TODO: Fix below (below is attempt to redirect to previous page before forced login - doesn't work rn)
                return (React.createElement(Redirect, { to: {
                        pathname: "/restart",
                        state: { next: routeProps.location.pathname },
                    } }));
            }
            // stages: 1) name missing 2) address missing 3) docs missing
            var stages = { 1: "/u/details", 2: "/u/addr", 3: "/u/cdd" };
            if (data.me && data.me.onboardingStage && data.me.onboardingStage !== 0) {
                // finished loading && user exists && BUT user not fully registered => render component
                // to stop typescript from complaining:
                return (React.createElement(Redirect, { to: {
                        pathname: stages[data.me.onboardingStage],
                        state: { next: routeProps.location.pathname },
                    } }));
            }
            // finished loading && user exists => render component
            // to stop typescript from complaining:
            var Component = component;
            return React.createElement(Component, __assign({}, routeProps));
        };
        return _this;
    }
    C.prototype.render = function () {
        // data comes from HOC below
        // destructure object and pull out data
        // `data: _` prevents 'unused variable' error
        // not using component here becaue we want to use it for a custom render method
        var _a = this.props, _ = _a.data, __ = _a.component, rest = __rest(_a, ["data", "component"]);
        return React.createElement(Route, __assign({}, rest, { render: this.renderRoute }));
    };
    return C;
}(React.PureComponent));
var meQuery = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query MeQuery {\n    me {\n      user {\n        email\n      }\n      onboardingStage\n    }\n  }\n"], ["\n  query MeQuery {\n    me {\n      user {\n        email\n      }\n      onboardingStage\n    }\n  }\n"])));
export var AuthRoute = graphql(meQuery)(C);
var templateObject_1;
//# sourceMappingURL=AuthRoute.js.map